import ky, { HTTPError } from 'ky';

export const api = ky.create({
  prefixUrl: import.meta.env.VITE_API_URL ?? '/api/v1',
  credentials: 'include',
  retry: 0,
  hooks: {
    beforeError: [
      async (error) => {
        try {
          const body = await error.response.json<{ error?: string }>();
          if (body.error) error.message = body.error;
        } catch {
          // ignora — usa mensagem padrão
        }
        return error;
      },
    ],
  },
});

export { HTTPError };
